export type PaidPartialInvoice = {
  id: string;
  referenceId: string;
  issueDate: string | null;
  status: string;
  netAmount: number;
  vatAmount: number;
  grossAmount: number;
  /** Sicherheitseinbehalt Brutto dieser Abschlagsrechnung (0 wenn keiner). */
  retentionGross?: number;
};

type FinalInvoiceTotalsInput = {
  baseNetAmount: number;
  baseVatAmount: number;
  paidPartials: PaidPartialInvoice[];
};

export type FinalInvoiceTotals = {
  paidPartialNetTotal: number;
  paidPartialVatTotal: number;
  paidPartialGrossTotal: number;
  finalNetAmount: number;
  finalVatAmount: number;
  finalGrossAmount: number;
};

export function roundMoney(value: number): number {
  return Math.round(value * 100) / 100;
}

/**
 * Deducts prior Abschläge at stored face value (net/VAT/gross).
 * Skonto is a payment condition only — never reduce these amounts by cash discount taken
 * (§ 14 Abs. 5 / § 17 UStG: the invoice chain keeps the billed totals).
 */
export function computeFinalInvoiceTotals(input: FinalInvoiceTotalsInput): FinalInvoiceTotals {
  const paidPartialNetTotal = roundMoney(
    input.paidPartials.reduce((sum, item) => sum + item.netAmount, 0),
  );
  const paidPartialVatTotal = roundMoney(
    input.paidPartials.reduce((sum, item) => sum + item.vatAmount, 0),
  );
  const paidPartialGrossTotal = roundMoney(
    input.paidPartials.reduce((sum, item) => sum + item.grossAmount, 0),
  );

  const finalNetAmount = roundMoney(input.baseNetAmount - paidPartialNetTotal);
  const finalVatAmount = roundMoney(input.baseVatAmount - paidPartialVatTotal);
  const finalGrossAmount = roundMoney(finalNetAmount + finalVatAmount);

  return {
    paidPartialNetTotal,
    paidPartialVatTotal,
    paidPartialGrossTotal,
    finalNetAmount,
    finalVatAmount,
    finalGrossAmount,
  };
}
